import Figure from '../../../components/Figure/Figure';
import useTheme from '../../../components/ThemeProvider/useTheme';
import objectToQueryString from '../../../helpers/url/objectToQueryString';
import GpsCoordinate from '../../types/GpsCoordinate';

type StaticGoogleMapProps = {
    apiKey: string;
    gps: GpsCoordinate;
    zoom?: number;
    width: number;
    height: number;
};

const StaticGoogleMap = ({
    apiKey,
    gps,
    width,
    height,
    zoom = 15,
}: StaticGoogleMapProps) => {
    const theme = useTheme();
    const brandColor = theme.colors.brand.default.tint.replace('#', '0x');

    const baseUrl = `https://maps.googleapis.com/maps/api/staticmap?`;
    const params = {
        center: `${gps.lat},${gps.long}`,
        zoom: zoom.toString(),
        size: `${width}x${height}`,
        maptype: 'roadmap',
        markers: `color:${brandColor}|${gps.lat},${gps.long}`,
        key: apiKey,
    };

    return (
        <Figure
            src={`${baseUrl}${objectToQueryString(params)}`}
            defaultPlaceholderRatio={height / width}
            borderRadius="all"
        />
    );
};

export default StaticGoogleMap;
